import { render, staticRenderFns } from "./fragment-integer-field.vue?vue&type=template&id=44d53800&scoped=true&"
import script from "./fragment-integer-field.vue?vue&type=script&lang=js&"
export * from "./fragment-integer-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d53800",
  null
  
)

export default component.exports